import { useState } from 'react';

const socials = [
  { icon: 'ri-wechat-line', label: '微信' },
  { icon: 'ri-weibo-line', label: '微博' },
  { icon: 'ri-qq-line', label: 'QQ' },
  { icon: 'ri-link', label: '复制链接' },
];

export default function ShareBar({ title }: { title: string }) {
  const [open, setOpen] = useState(false);
  const [toast, setToast] = useState('');

  const showToast = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(''), 2000);
  };

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      showToast('链接已复制到剪贴板');
    } catch {
      showToast('复制失败，请手动复制地址栏链接');
    }
    setOpen(false);
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 h-10 px-5 rounded-md border border-background-300 text-foreground-700 text-sm font-semibold hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-share-forward-line text-lg" />
        分享
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} aria-hidden="true" />
          <div className="absolute left-0 top-full mt-2 z-40 w-56 p-3 rounded-lg bg-background-50 border border-background-200 shadow-sm">
            <p className="text-xs text-foreground-500 px-1">分享《{title}》</p>
            <div className="mt-2.5 grid grid-cols-2 gap-2">
              {socials.map((s) => (
                <button
                  key={s.label}
                  type="button"
                  onClick={() => (s.icon === 'ri-link' ? handleCopy() : (setOpen(false), showToast(`已唤起 ${s.label} 分享（演示）`)))}
                  className="flex items-center gap-2 h-9 px-3 rounded-md bg-background-100 hover:bg-secondary-100 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-foreground-600`} />
                  <span className="text-xs text-foreground-700 whitespace-nowrap">{s.label}</span>
                </button>
              ))}
            </div>
            <p className="mt-2.5 px-1 text-xs text-foreground-400 leading-relaxed">分享为前端演示，不涉及第三方接口。</p>
          </div>
        </>
      )}

      {toast && (
        <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50 px-4 py-2.5 rounded-md bg-foreground-950 text-background-50 text-sm shadow-sm">
          {toast}
        </div>
      )}
    </div>
  );
}